import React from 'react';

const Unauthorized = () => (
  <div style={{ paddingTop: '120px', minHeight: '60vh', textAlign: 'center' }}>
    <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Unauthorized</h2>
    <p style={{ fontSize: '1.25rem' }}>You do not have permission to view this page.</p>
  </div>
);

export default Unauthorized; 